import { useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";

/** Encapsulates Stripe billing calls and the preview/checkout UI state. */
export function useBillingActions(refreshPlan) {
  const [busy, setBusy] = useState(null);        // lookupKey currently being checked-out
  const [managing, setManaging] = useState(false);
  const [preview, setPreview] = useState(null);  // { loading, data?, lookupKey }
  const [confirming, setConfirming] = useState(false);

  async function startCheckout(lookupKey) {
    setBusy(lookupKey);
    try {
      const { data } = await api.post("/billing/checkout", {
        origin_url: window.location.origin,
        lookup_key: lookupKey,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatError(e));
      setBusy(null);
    }
  }

  async function openPortal() {
    setManaging(true);
    try {
      const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
      window.location.href = data.portal_url;
    } catch (e) {
      toast.error(formatError(e));
      setManaging(false);
    }
  }

  async function openPreview(lookupKey) {
    setPreview({ loading: true, lookupKey });
    try {
      const { data } = await api.post("/billing/preview", { lookup_key: lookupKey });
      setPreview({ loading: false, data, lookupKey });
    } catch (e) {
      toast.error(formatError(e));
      setPreview(null);
    }
  }

  async function confirmChange() {
    if (!preview?.lookupKey) return;
    setConfirming(true);
    try {
      await api.post("/billing/change-plan", { lookup_key: preview.lookupKey });
      toast.success("Plan updated");
      setPreview(null);
      refreshPlan?.();
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setConfirming(false);
    }
  }

  function closePreview() { setPreview(null); }

  return {
    busy, managing, preview, confirming,
    startCheckout, openPortal, openPreview, confirmChange, closePreview,
  };
}
